import { useTranslation } from 'next-i18next';

import FormCTA from './FormCTA';

import { useAppointmentStore, useFormSectionStore } from '@src/store';
import { slugify } from '@src/utils/slugify';

export const RenderCTA = (name: string, confirmAppointment?: () => void) => {
	const { t } = useTranslation('formCTA');
	switch (name) {
		case 'Date & Time':
			return (
				<FormCTA
					hideContinue={!useAppointmentStore.getState().appointmentSlot}
					primaryButtonText="Continue"
					onClick={(e) => {
						e.preventDefault();
						useFormSectionStore.getState().completeActiveNode();
					}}
				/>
			);
		case 'Appointment Review':
			return (
				<FormCTA
					isAppointmentReview
					onClick={confirmAppointment}
					/*
					onClick={(e) => {
      				e.preventDefault();
					}
					*/
					primaryButtonText={t('confirmAppt')}
				/>
			);
		case 'Confirmation':
			return null;
		default:
			return <FormCTA form={slugify(name)} primaryButtonText="Continue" />;
	}
};

export const renderCTAES = (name: string, confirmAppointment?: () => void) => {
	switch (name) {
		case 'Date & Time':
			return (
				<FormCTA
					hideContinue={!useAppointmentStore.getState().appointmentSlot}
					primaryButtonText="Continuar"
					onClick={(e) => {
						e.preventDefault();
						useFormSectionStore.getState().completeActiveNode();
					}}
				/>
			);
		case 'Appointment Review':
			return <FormCTA isAppointmentReview onClick={confirmAppointment} primaryButtonText="Confirmar mi cita" />;
		case 'Confirmation':
			return null;
		default:
			return <FormCTA form={slugify(name)} primaryButtonText="Continuar" />;
	}
};
